import { render, staticRenderFns } from "./PosCollectionsReport.vue?vue&type=template&id=1981c910&"
import script from "./PosCollectionsReport.vue?vue&type=script&lang=js&"
export * from "./PosCollectionsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports